import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '1 — ¿Cómo recibo el Lengua Pack después de comprar?',
  a: 'Al confirmar el pago recibís un email con acceso inmediato a todos los PDFs. En menos de 5 minutos ya podés abrir el primer tomo desde tu celu o compu.'
}, {
  q: '2 — ¿Sirve para mi provincia?',
  a: 'Sí. Todo el material está alineado al currículo nacional argentino 2026 y es compatible con los diseños curriculares de todas las provincias.'
}, {
  q: '3 — ¿Está en blanco y negro?',
  a: 'Sí. Todo está diseñado para que quede perfecto en fotocopiadora en blanco y negro. No necesitás impresora a color ni nada especial.'
}, {
  q: '4 — ¿Los 6 bonus están en todas las ofertas?',
  a: 'Sí. Los 6 bonus estratégicos están incluidos en el Pack Primaria, el Pack Secundaria y el Pack Completo. Sin costo extra en ninguna opción.'
}, {
  q: '5 — ¿Puedo comprar Primaria ahora y Secundaria después?',
  a: 'Sí. Cada pack se compra por separado. Aunque si querés los dos niveles, el Pack Completo te sale mucho más conveniente.'
}, {
  q: '6 — ¿Los Ebooks Élite están en todas las ofertas?',
  a: 'No. Los Ebooks Élite (Planificación Anual + Proyectos Institucionales) están incluidos SOLO en el Pack Completo ($27.990). Es el único que los tiene.'
}, {
  q: '7 — ¿Está actualizado al currículo vigente?',
  a: 'Sí. Todo el contenido está revisado y alineado a los NAP y diseños curriculares vigentes en Argentina para el ciclo lectivo 2026.'
}, {
  q: '8 — ¿Qué pasa si no tengo internet en la escuela?',
  a: 'Una vez que descargás los PDFs los tenés para siempre en tu dispositivo. No necesitás internet para usarlos. Son tuyos.'
}, {
  q: '9 — ¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no te gusta por cualquier motivo, te devolvemos el 100% del dinero. Sin formularios ni explicaciones.'
}, {
  q: '10 — ¿Qué diferencia tiene con otros packs que vi?',
  a: 'La mayoría vende hojas sueltas sin secuencia ni criterio. El Lengua Pack es un sistema: cada tomo tiene progresión didáctica, solucionario, guía docente y está pensado para el aula argentina real. No para una escuela de España o México.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 bg-stone-50" data-id="element-41">
      <div className="max-w-3xl mx-auto px-4" data-id="element-42">
        <h2 className="text-3xl md:text-4xl font-black text-center text-stone-900 mb-12" data-id="element-43">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-44">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-stone-200 rounded-xl overflow-hidden shadow-sm" data-id="element-45">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-46">
                <span className="font-bold text-stone-900 text-lg" data-id="element-47">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-stone-500 transition-transform ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-48" />
              </button>
              <AnimatePresence data-id="element-49">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="px-6 pb-4 text-stone-600 font-medium" data-id="element-50">
                    {faq.a}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}